export default __webpack_public_path__ + "static/media/avatar-2.56ca7852.jpg";